// @react
import React from 'react'
// @types
import type { ReactElement } from 'react'
// @libraries
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'
import classNames from 'classnames'
// @components
import Colors from '@bit/atd.web.colors'
import Button from '@bit/atd.web.button'
import TextLink from '@bit/atd.web.text-link'
// @constants
import { ExternalRouteNames } from 'constants/routeNames'
import strings from 'lib/constants/strings'

const useStyles = makeStyles({
  container: {
    color: Colors.black,
  },
  title: {
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '26px',
    '& + $description': {
      marginTop: '8px',
    },
  },
  description: {
    fontSize: '16px',
    marginBottom: '24px',
  },
  cta: {
    fontSize: '18px',
    fontWeight: 500,
  },
  phoneCallout: {},
  phone: {
    color: Colors.ctaPrimary,
  },
})

type PropTypes = {
  variant: 'callCustomer' | 'launchLMS'
}

const callCustomer = {
  title: strings.BENEFITS.MEMBER_BENEFITS.MICRO_COURSE_LIB_NO_ACCESS.TITLE,
  description:
    strings.BENEFITS.MEMBER_BENEFITS.MICRO_COURSE_LIB_NO_ACCESS.DESCRIPTION,
}

const launchLMS = {
  title: strings.BENEFITS.MEMBER_BENEFITS.COURSES_WITH_ACCESS.TITLE,
  description: strings.BENEFITS.MEMBER_BENEFITS.COURSES_WITH_ACCESS.DESCRIPTION,
}

const phoneNumber = '+1.800.628.2783'

const Courses = ({ variant }: PropTypes): ReactElement => {
  /******************************************
   * HOOKS
   ******************************************/

  const classes = useStyles()
  const text = variant === 'callCustomer' ? callCustomer : launchLMS

  /******************************************
   * RENDERS
   ******************************************/

  const renderCallCustomerBtn = () => {
    return (
      <Grid className={classes.phoneCallout} container>
        <Grid item>
          <Typography className={classes.cta} component={'p'}>
            Call Customer Care:{' '}
            <TextLink
              className={classNames(classes.phone)}
              href={`tel:${phoneNumber}`}
            >
              {phoneNumber}
            </TextLink>
          </Typography>
        </Grid>
      </Grid>
    )
  }

  return (
    <div className={classes.container}>
      <Typography className={classes.title} variant="h6" component={'h4'}>
        {text.title}
      </Typography>
      <Typography
        className={classes.description}
        variant="body1"
        component={'p'}
      >
        {text.description}
      </Typography>

      {variant === 'callCustomer' ? (
        renderCallCustomerBtn()
      ) : (
        <Button href={ExternalRouteNames.SSO_LIBRARY} variant="primary">
          View the Library
        </Button>
      )}
    </div>
  )
}

export default Courses
